import { tabProps } from "@/utils/globalPropsTypes";
import { Form, InputNumber, Select, Switch } from "antd";
import React from "react";
import IconSelect from "@/components/Common/IconSelect";

function CounterTab({ editItem }) {
  const { component, counterType } = editItem;

  return (
    <>
      {["counter", "splitCounter"].includes(component) && (
        <>
          <Form.Item name="counterDataType" initialValue="parameter" label="Select Counter Data Type">
            <Select
              style={{ width: "100%" }}
              placeholder="Select Counter Data Type"
              options={[
                { label: "Parameter Data", value: "parameter" },
                { label: "Custom Data", value: "custom" },
              ]}
            />
          </Form.Item>
          {["counter"].includes(component) && (
            <Form.Item name="counterType" label="Counter Layout" initialValue="content-middle">
              <Select style={{ width: "100%" }} placeholder="Select Counter Layout" options={layoutOptions} />
            </Form.Item>
          )}
          {counterType && counterType.includes("icon") && (
            <>
              <Form.Item label="Icon" name="icon">
                <IconSelect placeholder="Select Icon" columns={4} />
              </Form.Item>
            </>
          )}

          <Form.Item initialValue="14" name="valueFontSize" label="Counter Value Font Size (pt)">
            <InputNumber style={{ width: "100%" }} placeholder="Select Counter Value Font Size" />
          </Form.Item>

          <Form.Item
            layout="horizontal"
            initialValue={true}
            label="Show Unit"
            name="showUnit"
            colon={false}
            className="right-label mb-0"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            layout="horizontal"
            // initialValue={true}
            label="Dynamic Background"
            name="dynamicBg"
            colon={false}
            className="right-label mb-0"
          >
            <Switch />
          </Form.Item>
        </>
      )}
    </>
  );
}

export default CounterTab;

const layoutOptions = [
  {
    label: "Without Icon (Content Is Middle)",
    value: "content-middle",
  },
  {
    label: "Without Icon (Content Is Left)",
    value: "content-left",
  },
  {
    label: "Without Icon (Content Is Right)",
    value: "content-right",
  },
  {
    label: "With Icon (Icon Is Left, Content Is Right)",
    value: "icon-left-content-right",
  },
  {
    label: "With Icon (Icon Is Right, Content Is Left)",
    value: "icon-right-content-left",
  },
];

CounterTab.propTypes = tabProps;
